import { Authority } from '@/shared/security/authority';

const JhiUserManagementViewComponent = () => import('@/admin/user-management/user-management-view.vue');
const JhiUserManagementEditComponent = () => import('@/admin/user-management/user-management-edit.vue');
const UserManagementListComponent = () => import('@/admin/user-management/user-management-list.vue');
const JhiDocsComponent = () => import('@/admin/docs/docs.vue');
const JhiConfigurationComponent = () => import('@/admin/configuration/configuration.vue');
const JhiHealthComponent = () => import('@/admin/health/health.vue');
const JhiLogsComponent = () => import('@/admin/logs/logs.vue');
const JhiMetricsComponent = () => import('@/admin/metrics/metrics.vue');
const UserResetPassword = () => import('@/admin/user-management/reset-password/user-reset-password.vue');

export default [
  {
    path: '/admin/user-management',
    name: 'JhiUser',
    component: UserManagementListComponent,
    meta: {
      authorities: [Authority.ADMIN],
      pageTitle: 'Users',
      action: 'view',
      resource: 'User',
    },
  },

  {
    path: '/admin/user-management/new',
    name: 'JhiUserCreate',
    component: JhiUserManagementEditComponent,
    meta: {
      authorities: [Authority.ADMIN],
      pageTitle: 'Create User',
    },
  },
  {
    path: '/admin/user-management/:userId/edit',
    name: 'JhiUserEdit',
    component: JhiUserManagementEditComponent,
    meta: { authorities: [Authority.ADMIN] },
    pageTitle: 'Edit User',
  },
  {
    path: '/admin/user-management/:userId/view',
    name: 'JhiUserView',
    redirect: '/admin/user-management/:userId/view/details',
    component: JhiUserManagementViewComponent,
    children: [
      {
        path: 'details',
        name: 'UserOverview',
      },
      {
        path: 'user-reset-password',
        name: 'UserResetPassword',
        component: UserResetPassword,
        meta: {
          resource: 'User',
          action: 'reset_password',
        },
      },
    ],
  },
  {
    path: '/admin/docs',
    name: 'JhiDocsComponent',
    component: JhiDocsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/health',
    name: 'JhiHealthComponent',
    component: JhiHealthComponent,
    meta: {
      authorities: [Authority.ADMIN],
      resource: 'Health',
      action: 'read',
    },
  },
  {
    path: '/admin/logs',
    name: 'JhiLogsComponent',
    component: JhiLogsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/metrics',
    name: 'JhiMetricsComponent',
    component: JhiMetricsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/configuration',
    name: 'JhiConfigurationComponent',
    component: JhiConfigurationComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
];
